import 'react';
import { css } from 'reakit/styled';
import { theme } from 'styled-tools';
import 'styled-selector';
import '../styled/selector.js';
import 'lodash/get';
import '../styled/space.js';
import styled from '../styled/index.js';
import '../chunk-ad6ad343.js';
import 'reakit/Box';
import 'reakit/Block';
import 'reakit/Inline';
import 'reakit/InlineBlock';
import 'reakit/Flex';
import 'reakit/InlineFlex';
import 'reakit/Grid';
import '../Set/styled.js';
import Set from '../Set/index.js';
var FieldSet = styled(Set).withConfig({
  displayName: "styled__FieldSet",
  componentId: "f1ef80-0"
})(["", ";&{", ";}"], function (props) {
  return props.isHorizontal ? css(["display:flex;& > *{flex:1;}@media screen and (max-width:", "px){display:block;margin-top:0rem;}&{", ";}"], theme('fannypack.layout.tabletBreakpoint'), theme('fannypack.FieldSet.horizontal')) : css(["display:block;&{", ";}"], theme('fannypack.FieldSet.vertical'));
}, theme('fannypack.FieldSet.base'));
export default FieldSet;
export { FieldSet };